
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/[filter]",
      function () {
        return require("private-next-pages/events/[filter].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/[filter]"])
      });
    }
  